<template>
    <!-- <el-select
        v-if="permissionsShow"
        v-model="currentValue"
        :clearable="clearable"
        :multiple="multiple"
        :collapse-tags="collapseTags"
        :filterable="filterable"
        :size="size"
        :multiple-limit="multipleLimit"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :no-data-text="$t(noDataText)"
        :style="{ width: width + 'px' }"
        ref="reference"
        :value-key="valueKey"
        :allow-create="allowCreate"
        :default-first-option="defaultFirstOption"
        @change="_changeValue"
        @clear="_clear"
        @blur="_blur"
        @focus="_focus"
        @visible-change="_visibleChange"
        @remove-tag="_removeTag"
        :filter-method="_filter"
        :placeholder="$t(placeholder)"
    >
        <el-option :style="{ width: width + 'px' } + ';color:rgb(64,158,255)'" v-if="lastPage" :value="lastPageValue" :label="$t('component.PREVIOUS_OPTIONS')"></el-option>
        <el-option
            :style="{ width: width + 'px' }"
            v-for="item in showOptions"
            :key="hasBasicTypes ? item : item[keys]"
            :label="hasBasicTypes ? $t(item) : $t(item[text])"
            :value="hasValueObject || hasBasicTypes ? item : item[keys]"
            :disabled="item.disabled"
            :title="hasBasicTypes ? $t(item) : $t(item[text])"
        >
        </el-option>
        <el-option :style="{ width: width + 'px' } + ';color:rgb(64,158,255)'" v-if="nextPage" :value="nextPageValue" :label="$t('component.MORE_OPTIONS')"></el-option>
        <el-option disabled="disabled" :style="{ width: width + 'px' } + ';'" v-if="maxTip" label="最多显示前200条数据"></el-option>
    </el-select> -->

    <el-select
        v-if="permissionsShow"
        v-model="currentValue"
        :clearable="clearable"
        :multiple="multiple"
        :collapse-tags="collapseTags"
        :filterable="filterable"
        :size="size"
        :multiple-limit="multipleLimit"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :no-data-text="$t(noDataText)"
        :style="{ width: width + 'px' }"
        ref="reference"
        :value-key="valueKey"
        :allow-create="allowCreate"
        :default-first-option="defaultFirstOption"
        @clear="_clear"
        @blur="_blur"
        @focus="_focus"
        @visible-change="_visibleChange"
        @remove-tag="_removeTag"
        :filter-method="_filter"
        :placeholder="$t(placeholder)"
        @change="selectChange"
    >
        <!-- 用来记录上一次选中的值,避免翻页后显示成id -->
        <el-option style="display:none" v-for="nowItem in nowOptions" :key="nowItem[keys]" :style="{ width: width + 'px' }" :label="nowItem[text]" :value="nowItem[keys]"></el-option>
        <el-option
            :style="{ width: width + 'px' }"
            v-for="item in showOptions"
            :key="hasBasicTypes ? item : item[keys]"
            :label="hasBasicTypes ? $t(item) : typeof $t(item[text]) == 'object' ? item[text] : $t(item[text])"
            :value="hasValueObject || hasBasicTypes ? item : item[keys]"
            :disabled="item.disabled"
            :title="hasBasicTypes ? $t(item) : typeof $t(item[text]) == 'object' ? item[text] : $t(item[text])"
            @click.native="selectClick"
        ></el-option>
        <!-- <el-option disabled="disabled" :style="{ width: width + 'px' } + ';'" v-if="maxTip" label="最多显示前200条数据"></el-option> -->
        <div style="bottom: 0;width: 100%;" v-if="showPage">
            <el-pagination
                class="select_pagination"
                background
                small
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="count"
                layout="prev, next, jumper"
            ></el-pagination>
        </div>
    </el-select>
</template>
<script>
import apiAxios from '../../commons/systemCommon/apiAxios';
export default {
    props: {
        /* 下拉框id值关键字 */
        keys: {
            type: String,
            default: function() {
                return 'value';
            }
        },
        /* 显示文字的关键字 */
        text: {
            type: String,
            default: function() {
                return 'label';
            }
        },
        /* 部件的下拉选项数组 */
        options: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 选中的选择值 */
        value: {
            required: true
        },
        /* 可将选择器清空。需要注意的是，clearable属性仅适用于单选 */
        clearable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /*  设置multiple属性即可启用多选 默认情况下选中值会以 Tag 的形式展现,可以设置collapse-tags属性将它们合并为一段文字 */
        multiple: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 将多选项合并为一段文字 */
        collapseTags: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否启用搜索功能 */
        filterable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 尺寸 medium/small/mini */
        size: {
            type: String,
            default: function() {
                return 'medium';
            }
        },
        /* 多选时用户最多可以选择的项目数，为 0 则不限制 */
        multipleLimit: {
            type: Number,
            default: function() {
                return 0;
            }
        },
        /* 是否禁用 */
        disabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 自动补全 */
        autocomplete: {
            type: String,
            default: function() {
                return 'off';
            }
        },
        /* 没有选项时显示文字 */
        noDataText: {
            type: String,
            default: function() {
                return 'common.NO_DATA';
            }
        },
        /* 默认提示选择文字 */
        placeholder: {
            type: String,
            default: function() {
                return 'component.PLEASE_SELECT';
            }
        },
        /* 宽度设置 */
        width: {
            type: [Number, String],
            default: function() {
                return 200;
            }
        },
        /* 是否为基本类型的数据，例如['A','B']形式 */
        hasBasicTypes: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 作为 value 唯一标识的键名，绑定值为对象类型时必填 */
        valueKey: {
            type: String,
            default: 'value'
        },
        pageSize: {
            type: Number,
            default: function() {
                return 10;
            }
        },
        /* 是否绑定对象 */
        hasValueObject: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        allowCreate: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        defaultFirstOption: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 接口名称
        url: {
            type: String,
            default: function() {
                return '';
            }
        },
        // 接口请求参数
        urlParam: {
            type: [Number, String, Array, Object],
            default: function() {
                return null;
            }
        },
        requestType: {
            type: String,
            default: function() {
                return 'GET';
            }
        },
        //是否分页
        isPage: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },

    watch: {
        /* 监听数据的变化，实时生效 */
        options: {
            handler: function(newVal) {
                this.currentOptions = newVal;
                newVal = null;
            },
            deep: true
        },
        value(newVal) {
            this.currentValue = newVal;
            if (this.url != '' && this.needInitValue) {
                this.initValue();
            }
        },
        /* 监听请求参数的变化，实时调用接口*/
        urlParam: {
            handler: function() {
                this._queryHttp();
            },
            deep: true
        },
        currentValue(newVal, oldVal) {
            if (newVal === this.nextPageValue || newVal === this.lastPageValue) {
                this.currentValue = oldVal;
            } else {
                this.currentValue = newVal;
            }
        },
        currentOptions: {
            handler: function() {
                this._initData();
            },
            deep: true
        }
    },
    data() {
        return {
            currentValue: {
                required: true
            },
            /* 是否满足显示权限 */
            permissionsShow: true,
            lastPage: false, // 是否显示先前选项
            nextPage: false, // 是否显示更多选项
            pageNum: 1, // 当前页
            pageValue: '', // 先前选中对象
            nextPageValue: 'nextPageValue',
            lastPageValue: 'lastPageValue',
            filterVal: '', // 搜索框查询内容
            visible: true,
            queryData: [], //接口查询的数据
            currentOptions: [], //要处理的数据
            showOptions: '', // 显示的对象
            count: 0, //总数
            maxTip: false,
            showPage: false,
            nowOptions: [],
            needInitValue:true
        };
    },
    beforeDestroy() {
        // this.options = null;
        this.currentValue = null;
        /* 是否满足显示权限 */
        this.permissionsShow = null;
        this.lastPage = null;
        this.nextPage = null;
        this.starNum = null;
        this.endNum = null;
        this.pageValue = null;
        this.nextPageValue = null;
        this.lastPageValue = null;
        this.filterVal = null;
        this.visible = null;
        this.showOptions = null;
    },
    /* 将select默认值设置为选中状态 */
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        this.currentValue = this.$util.clone(this.value);
        if (this.options.length > 0) {
            this.currentOptions = this.options;
        }
        this.initValue();
    },
    methods: {
        initValue(){
            let _initParam = this.$util.clone(this.value);
            let _param = null;
            if(this.value){
                this.needInitValue = false;
                _param = {
                    [this.keys]: _initParam
                };
            }
            this._initData(null, _param);
        },
        handleCurrentChange(value) {
            this.pageNum = value;
            this._queryHttp(this.filterVal);
        },
        selectChange(value) {
            this.currentValue = value;
            /* 实现子组件与父组件的数据实时传递 */
            this.$emit('input', value);
            /* 在值改变时触发,父组件可进行注册change方法 */
            this.$emit('change', value);
        },
        selectClick() {
            if (!this.multiple) {
                this.$nextTick(function() {
                    this.$refs.reference.blur();
                });
            }
        },
        // 请求后台接口
        _queryHttp(value, _initParam) {
            let pageSize = this.pageSize;
            // if (value) {
            //     //搜索时最多展示200条
            //     pageSize = 200;
            //     this.maxTip = false;
            //     this.showPage = true;
            // } else {
            //     this.showPage = false;
            // }
            let needPage = this.isPage;
            if(_initParam){
                needPage = false;
            }
            let param = {
                pageNum: this.pageNum,
                currentPage: this.pageNum,
                pageSize: pageSize,
                isPage: needPage,
                ..._initParam,
                ...this.urlParam
            };
            param[this.text] = value;
            if (this.requestType === 'GET') {
                apiAxios.get(this.url, param, response => {
                    if (response.status !== this.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        return;
                    }
                    let options = JSON.parse(JSON.stringify(response.data.content));
                    if(_initParam){
                        this.addSelectedOption(options,this.currentValue);
                        return;
                    }
                    //记录当前选中的对象
                    this.addSelectedOption(this.showOptions,this.currentValue);
                    this.showOptions = options;
                    this.count = response.data.count;
                    if (this.isPage && !value) {
                        if (this.count / this.pageSize > 1 && this.count / this.pageSize > this.pageNum) {
                            this.nextPage = true;
                        } else {
                            this.nextPage = false;
                        }
                        if (this.count / this.pageSize > 1 && this.pageNum > 1) {
                            this.lastPage = true;
                        } else {
                            this.lastPage = false;
                        }
                        if (this.count > this.pageSize) {
                            this.showPage = true;
                        }
                    } else {
                        this.nextPage = false;
                        this.lastPage = false;
                    }
                    this.$emit('success');
                    // if (value && this.count > 200) {
                    //     this.maxTip = true;
                    // }
                });
            } else {
                apiAxios.postRequestBody(this.url, param, response => {
                    if (response.status !== this.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        return;
                    }
                    let options = JSON.parse(JSON.stringify(response.data.content));
                    if(_initParam){
                        this.addSelectedOption(options,this.currentValue);
                        return;
                    }
                    //记录当前选中的对象
                    this.addSelectedOption(this.showOptions,this.currentValue);
                    this.showOptions = options;
                    this.count = response.data.count;
                    if (this.isPage && !value) {
                        if (this.count / this.pageSize > 1 && this.count / this.pageSize > this.pageNum) {
                            this.nextPage = true;
                        } else {
                            this.nextPage = false;
                        }
                        if (this.count / this.pageSize > 1 && this.pageNum > 1) {
                            this.lastPage = true;
                        } else {
                            this.lastPage = false;
                        }
                        if (this.count > this.pageSize) {
                            this.showPage = true;
                        }
                    } else {
                        this.nextPage = false;
                        this.lastPage = false;
                    }
                    this.$emit('success');
                    // if (value && this.count > 200) {
                    //     this.maxTip = true;
                    // }
                });
            }
        },
        //记录当前选中的对象
        addSelectedOption(showOptions,currentValue){
            if (!this.$util.isEmpty(showOptions) && !this.$util.isEmpty(currentValue)) {
                let arr = [];
                showOptions.forEach(element => {
                    if(Array.isArray(currentValue)){
                        currentValue.forEach(value =>{
                                if(element[this.keys] == value){
                                    arr.push(element);
                                }
                            }
                        );
                    }else{
                        if(element[this.keys] == currentValue){
                            arr.push(element);
                        }
                    }
                });
                //去重
                let add = arr.filter(item=>!this.nowOptions.some(ele=>ele[this.keys]===item[this.keys]))
                this.nowOptions.push(...add);
            }
        },
        /* 初始化显示数据 */
        _initData(value, _param) {
            if (this.url != '') {
                // this.pageNum = 1;
                this._queryHttp(value, _param);
            } else {
                this.showOptions = this.currentOptions;
            }
        },
        /* 搜索框查找数据 */
        _filter(value) {
            this.pageNum = 1;
            if (this.filterable) {
                this.filterVal = value;
                if (!value) {
                    this._initData();
                } else {
                    if (this.url != '') {
                        this._queryHttp(value);
                    } else {
                        let optionData = [];
                        for (let i in this.currentOptions) {
                            let data = this.currentOptions[i];
                            if (data[this.text].indexOf(value) !== -1) {
                                optionData.push(data);
                            }
                        }
                        this.showOptions = optionData;
                    }
                }
            }
        },
        _changeValue(value) {
            this.pageValue = value;
            if (value !== this.nextPageValue && value !== this.lastPageValue && !this.multiple) {
                this._initData();
            }
            this._dealPageInfo(value);
            let val = value;
            if (this.multiple) {
                val = value[value.length - 1];
            }
            if (val === this.nextPageValue || value === this.lastPageValue) {
                return;
            }
            /* 实现子组件与父组件的数据实时传递 */
            this.$emit('input', value);
            /* 在值改变时触发,父组件可进行注册change方法 */
            this.$emit('change', value);
        },

        /* 处理分页数据 */
        _dealPageInfo(value) {
            if (this.multiple && value[value.length - 1] === this.nextPageValue) {
                value.pop();
                this._dealnextPage();
            } else if (this.multiple && value[value.length - 1] === this.lastPageValue) {
                value.pop();
                this._dealLastPage();
            } else if (value === this.nextPageValue) {
                this._dealnextPage();
            } else if (value === this.lastPageValue) {
                this._dealLastPage();
            }
        },
        _dealLastPage() {
            this.pageNum--;
            this._queryHttp();
        },
        _dealnextPage() {
            this.pageNum++;
            this._queryHttp();
        },
        /* 组件失去焦点时触发，父组件可进行blur方法注册 */
        _blur(event) {
            this.$emit('blur', event);
        },
        /* 组件获得焦点时触发，父组件可进行focus方法注册 */
        _focus(event) {
            if (!this.multiple) {
                this._initData();
            }
            this.$emit('focus', event);
        },
        /* 在点击由 clearable 属性生成的清空按钮时触发，父组件可进行clear方法注册 */
        _clear() {
            this.$emit('clear');
        },
        /* 下拉框出现/隐藏时触发 出现则为 true，隐藏则为 false */
        _visibleChange(val) {
            /* 搜索数据时，失去焦点后，数据重加载 */
            if (val) {
                this.filterVal = '';
                if (this.filterable && this.filterVal !== '') {
                    this._initData();
                }
            }
            /* 数据多选时，失去焦点后，数据重加载 */
            if (this.multiple && !this.visible) {
                this._initData();
            }
            this.visible = val;
            if (this.pageValue === this.nextPageValue || this.pageValue === this.lastPageValue) {
                this.pageValue = '';
                this.$refs.reference.visible = true;
            }

            this.$emit('visibleChange', val);
        },
        /* 多选模式下移除tag时触发,移除的tag值 */
        _removeTag(val) {
            this.$emit('removeTag', val);
        },
        focus() {
            this.$refs.reference.focus();
        },
        /* 选中 input 中的文字 */
        blur() {
            this.$refs.reference.blur();
        }
    }
};
</script>
